import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-hand-index-thumb mx-1" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.bots && _ctx.bots.length ===0 && _ctx.showBtn === true)
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 0,
          to: "/welcome-wizard",
          class: _normalizeClass(["", _ctx.classes])
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createTextVNode(" " + _toDisplayString(_ctx.translate("Click to test for free")), 1)
          ]),
          _: 1
        }, 8, ["class"]))
      : _createCommentVNode("", true)
  ]))
}